// Resize and compress images before sending to the API.
// Data tags don't need full-res — 1280px on the long side is plenty for OCR.

const MAX_DIMENSION = 1280;
const JPEG_QUALITY = 0.85;

export async function compressImage(file, { maxDimension = MAX_DIMENSION, quality = JPEG_QUALITY } = {}) {
  const dataUrl = await fileToDataUrl(file);
  return resizeDataUrl(dataUrl, maxDimension, quality);
}

export async function compressDataUrl(dataUrl, opts = {}) {
  return resizeDataUrl(dataUrl, opts.maxDimension || MAX_DIMENSION, opts.quality || JPEG_QUALITY);
}

function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function resizeDataUrl(dataUrl, maxDimension, quality) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      const scale = Math.min(1, maxDimension / Math.max(width, height));
      width = Math.round(width * scale);
      height = Math.round(height * scale);

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}
